import { render, staticRenderFns } from "./LoginVtexpForm.vue?vue&type=template&id=197510df&scoped=true&lang=pug&"
import script from "./LoginVtexpForm.vue?vue&type=script&lang=js&"
export * from "./LoginVtexpForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginVtexpForm.vue?vue&type=style&index=0&id=197510df&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197510df",
  null
  
)

export default component.exports